<template>
  <div v-if="$route.query.sales"
  class="flex flex-col lg:flex-row w-11/12 md:w-3/4 mx-auto space-y-4 lg:space-y-0 lg:space-x-10 min-h-screen my-12">
    <p class="text-xl md:text-2xl italic p-2 text-center w-full">Nessuna promozione disponibile</p>
  </div>
  <ais-instant-search
    v-else
    :search-client="searchClient"
    index-name="products"
    :class-names="{
      // eslint-disable-next-line max-len
      'ais-InstantSearch': 'flex flex-col lg:flex-row w-11/12 md:w-3/4 mx-auto space-y-4 lg:space-y-0 lg:space-x-10 min-h-screen my-12',
    }"
    :future="{ preserveSharedStateOnUnmount: false }"
    :routing="routing"
  >
    <div class="w-full md:w-1/5 hidden lg:block h-fit">
      <h3
        class="font-medium leading-none text-2xl mb-2"
      >
        {{ $t('frontoffice.products.filters') }}
      </h3>
      <div
        class="flex flex-col space-y-4"
      >
        <ais-clear-refinements>
          <template v-slot="{ refine }">
            <button
              @click.prevent="refine"
              @click.stop="clearData"
              class="ais-ClearRefinements-button"
            >
              {{ $t('filters.resetFilters') }}
            </button>
          </template>
        </ais-clear-refinements>
        <div>
          <p class="font-medium pb-1">{{ $t('frontoffice.products.brand') }}</p>
          <ais-refinement-list
            :class-names="{
              // eslint-disable-next-line max-len
              'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
              'ais-RefinementList-searchBox': 'w-full',
              'ais-SearchBox-input': 'placeholder:text-xs',
              'ais-RefinementList-showMore': 'mt-1',
              'ais-RefinementList-noResults': 'dark:text-white'
            }"
            attribute="COMPATIBILITA"
            :transform-items="divideLabel"
          />
        </div>
        <div>
          <p class="font-medium pb-1">Mechanism</p>
          <ais-refinement-list
            :class-names="{
              // eslint-disable-next-line max-len
              'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
              'ais-RefinementList-searchBox': 'w-full',
              'ais-SearchBox-input': 'placeholder:text-xs',
              'ais-RefinementList-showMore': 'mt-1',
              'ais-RefinementList-noResults': 'dark:text-white'
            }"
            attribute="HARP"
            :transform-items="transformItems"
          />
        </div>
        <!-- <div>
          <p class="font-medium pb-1">{{ $t('frontoffice.products.subcategory') }}</p>
          <ais-refinement-list
            :class-names="{
              // eslint-disable-next-line max-len
              'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100
              dark:checked:border-lh_red checked:border-lh_red',
              'ais-RefinementList-searchBox': 'w-full',
              'ais-SearchBox-input': 'placeholder:text-xs',
              'ais-RefinementList-showMore': 'mt-1',
              'ais-RefinementList-noResults': 'dark:text-white'
            }"
            :attribute="`subcategoryTranslations.${$i18n.locale}`"
          />
        </div> -->
        <div>
          <p class="font-medium pb-1">{{ $t('frontoffice.products.subcategory') }}</p>
          <ais-refinement-list
            :class-names="{
              // eslint-disable-next-line max-len
              'ais-RefinementList-checkbox': 'bg-transparent border-gray-400 dark:border-gray-100 dark:checked:border-lh_red checked:border-lh_red',
              'ais-RefinementList-searchBox': 'w-full',
              'ais-SearchBox-input': 'placeholder:text-xs',
              'ais-RefinementList-showMore': 'mt-1',
              'ais-RefinementList-noResults': 'dark:text-white'
            }"
            attribute="productSubcategoryName"
          />
        </div>
      </div>
    </div>
    <div class="w-full lg:w-4/5 lg:border-l lg:border-lh_lightGray lg:pl-6">
      <ais-configure
        :filters="filters"
      />
      <ProductsList />
    </div>
  </ais-instant-search>
</template>

<script>
import ProductsList from '@/components/products/ProductsList.vue';
import '@vuepic/vue-datepicker/dist/main.css';
import getSearchClient from '@/utils/search-services';
import {
  AisInstantSearch, AisRefinementList, AisClearRefinements, AisConfigure,
} from 'vue-instantsearch/vue3/es';

export default {
  components: {
    ProductsList,
    AisInstantSearch,
    AisRefinementList,
    AisClearRefinements,
    AisConfigure,
  },
  data() {
    const vueRouter = this.$router;
    // const subcategoryAttribute = `subcategoryTranslations.${this.$i18n.locale}`;
    return {
      activeButton: null,
      searchClient: getSearchClient(),
      hideFilters: true,
      harpOptions: {
        Lever: this.$t('frontoffice.products.lever'),
        Pedal: this.$t('frontoffice.products.pedal'),
      },
      routing: {
        router: {
          read() {
            return vueRouter.currentRoute.value.query;
          },
          write(routeState) {
            vueRouter.push({
              query: routeState,
            });
          },
          createURL(routeState) {
            return vueRouter.resolve({
              query: routeState,
            }).href;
          },
          onUpdate(cb) {
            if (typeof window === 'undefined') return;

            this.removeAfterEach = vueRouter.afterEach(() => {
              cb(this.read());
            });

            this.onPopState = () => {
              cb(this.read());
            };
            window.addEventListener('popstate', this.onPopState);
          },
          dispose() {
            if (typeof window === 'undefined') {
              return;
            }
            if (this.onPopState) {
              window.removeEventListener('popstate', this.onPopState);
            }
            if (this.removeAfterEach) {
              this.removeAfterEach();
            }
          },
        },
        stateMapping: {
          stateToRoute(uiState) {
            return {
              upcoming: vueRouter.currentRoute.value.query.upcoming,
              latest: vueRouter.currentRoute.value.query.latest,
              filter: vueRouter.currentRoute.value.query.filter,
              value: vueRouter.currentRoute.value.query.value,
              category: vueRouter.currentRoute.value.query.category,
              query: uiState.products.query,
              labels:
                uiState.products.refinementList
                && uiState.products.refinementList.ETICHETTA
                && uiState.products.refinementList.ETICHETTA.join('~'),
              brands:
                uiState.products.refinementList
                && uiState.products.refinementList.productBrandName
                && uiState.products.refinementList.productBrandName.join('~'),
              categories:
                uiState.products.refinementList
                && uiState.products.refinementList.productCategoryName
                && uiState.products.refinementList.productCategoryName.join('~'),
              subcategories:
                uiState.products.refinementList
                && uiState.products.refinementList.productSubcategoryName
                && uiState.products.refinementList.productSubcategoryName.join('~'),
              formats:
                uiState.products.refinementList
                && uiState.products.refinementList.SUPPORTO
                && uiState.products.refinementList.SUPPORTO.join('~'),
              authors:
                uiState.products.refinementList
                && uiState.products.refinementList.AUTORE
                && uiState.products.refinementList.AUTORE.join('~'),
              compatibility:
                uiState.products.refinementList
                && uiState.products.refinementList.COMPATIBILITA
                && uiState.products.refinementList.COMPATIBILITA.join('~'),
              harps:
                uiState.products.refinementList
                && uiState.products.refinementList.HARP
                && uiState.products.refinementList.HARP.join('~'),
              availableFrom:
                uiState.products.range
                && uiState.products.range.availableFromUnix,
              page: uiState.products.page,
            };
          },
          routeToState(routeState) {
            return {
              products: {
                query: routeState.query,
                refinementList: {
                  productBrandName: routeState.brands && routeState.brands.split('~'),
                  productCategoryName: routeState.categories && routeState.categories.split('~'),
                  productSubcategoryName: routeState.subcategories && routeState.subcategories.split('~'),
                  COMPATIBILITA: routeState.compatibility && routeState.compatibility.split('~'),
                  HARP: routeState.harps && routeState.harps.split('~'),
                },
                page: routeState.page,
              },
            };
          },
        },
      },
    };
  },
  props: ['harp_family', 'category', 'subcategory', 'compatibility'],
  computed: {
    filters() {
      if (!this.subcategory) return '';
      // eslint-disable-next-line max-len
      return `COMPATIBILITA="${this.compatibility}" AND harp="${this.harp_family}" AND productCategorySlug="${this.category}" AND productSubcategorySlug="${this.subcategory}"`;
    },
  },
  methods: {
    activePeriod(period) {
      this.activeButton = period;
      if (period) {
        this.date = [period.startDate, this.today];
      }
    },
    clearData() {
      this.date = null;
      this.activeButton = null;
    },
    showFilters() {
      this.hideFilters = !this.hideFilters;
    },
    divideLabel(items) {
      return items.map((item) => ({
        ...item,
        label: item.label.replaceAll('_', ' '),
      }));
    },
    transformItems(items) {
      return items.map((item) => ({
        ...item,
        label: this.harpOptions[item.value],
      }));
    },
  },
};
</script>

<style scoped>
.active {
  @apply text-lh_red border-2 border-lh_red
}
.datepicker {
  border: 0;
  border-bottom: 1px #9ca3af solid;
  border-radius: 0px;
  width: 100%;
  padding: 0 0 1px 2.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background-color: transparent;
  @apply dark:text-white dark:border-white
}
@media (min-width: 768px) {
  .datepicker {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
</style>
